import { ReportsListingFilters } from '../types';

export function collectReportFilters(filters: ReportsListingFilters) {
  return {
    created: {
      to: filters.to.toISOString(),
      from: filters.from.toISOString(),
    },
    isIncludeClosedDeals: filters.isIncludeClosedDeals,
    ...(filters.search ? { search: filters.search } : {}),
    ...(filters.stageName ? { stageName: filters.stageName } : {}),
    ...(filters.locationId ? { locationId: filters.locationId } : {}),
    ...(filters.departmentId ? { departmentId: filters.departmentId } : {}),
    ...(filters.salesPersonId ? { salesPersonId: filters.salesPersonId } : {}),
    ...(filters.salesManagerId ? { salesManagerId: filters.salesManagerId } : {}),
    ...(filters.financeManagerId ? { financeManagerId: filters.financeManagerId } : {}),
  };
}
